import { Box, IconButton, Typography } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import { ReactNode } from 'react'
import { DropzoneOptions, useDropzone } from 'react-dropzone'

import { useStyles } from './styles'

export interface DropzoneInputProps extends DropzoneOptions {
  activeLabel: string
  label: ReactNode
  files?: File[]
  labelViewImagesCount?: boolean
  onClearFiles?: () => void
  error?: string | (string | undefined)[]
}

export default function DropzoneInput({
  activeLabel,
  label,
  files,
  labelViewImagesCount = false,
  onClearFiles,
  error,
  ...props
}: DropzoneInputProps) {
  const classes = useStyles()

  const { getRootProps, getInputProps, isDragActive, inputRef } = useDropzone({
    ...props,
    noClick: true,
  })

  const handleClearFiles = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault()
    if (onClearFiles) onClearFiles()
    if (inputRef.current) {
      inputRef.current.value = ''
      inputRef.current.files = null
    }
  }

  const errors = (Array.isArray(error) ? error : [error]).filter(Boolean)

  return (
    <>
      <label
        {...getRootProps({
          role: 'button',
        })}
        className={classes.root}
        data-selected={!!files?.length}
        data-error={!!errors.length}
      >
        <input {...getInputProps()} />
        {!files?.length ? (
          <Typography variant='h3'>
            {isDragActive ? activeLabel : label}
          </Typography>
        ) : (
          <Box className={classes.selectedFiles}>
            <Typography variant='h3'>
              {labelViewImagesCount
                ? `${files.length} imagens selecionadas`
                : files?.map((file) => file.name).join(', ')}
            </Typography>
            <IconButton
              size='small'
              onClick={handleClearFiles}
              aria-label='Remover arquivos'
            >
              <Cancel />
            </IconButton>
          </Box>
        )}
      </label>
      {errors.map((message, index) => (
        <Typography
          key={`${message}-${index}`}
          className={classes.errorMessage}
          variant={'subtitle1'}
        >
          {message}
        </Typography>
      ))}
    </>
  )
}
